import { createFileRoute } from "@tanstack/react-router";

import { StripeFormPage } from "~/pages/connection-new/stripe-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/stripe",
)({
  component: StripeFormPage,
});
